import React from 'react';
import { Divider, Grid, Icon, IconButton, Typography } from '@material-ui/core';


import { HomeContext } from '../../HomeContext';
import { PageLocation } from '../../../../shared/enum/PageLocation';
import { AuthContext } from '../../../Authentication/AuthContext';
import { MenuItems } from '../../enums/MenuItems';
import MenuItemComponent from '../MenuItemComponent';

interface MenuInterface {
    toggleDrawer: (open: boolean, pageLocation: PageLocation | null) => (event: React.KeyboardEvent | React.MouseEvent) => void,
}
export default function MenuInfluencerICE({ toggleDrawer }: MenuInterface) {
    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);
    const clientEnable = homeContext.influencerClientEnable;
    const clientListEnable: any = homeContext.influencerListClientEnable;
    const [menuItemOpen, setMenuItemOpen] = React.useState<MenuItems>(MenuItems.NONE);

    const handleClickHeaderMenu = (item: number) => {
        if (item === menuItemOpen)
            setMenuItemOpen(MenuItems.NONE);
        else
            setMenuItemOpen(item);
    };

    return (
        <>
            {clientEnable ? (
                <>
                    {authContext.login.user.profile?.functionalities && (
                        <>
                            {authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Inicial Influencers') >= 0 && (
                                <>
                                    <MenuItemComponent
                                        key="dashboard-menu"
                                        principalItemTitle="Home"
                                        toggleDrawer={toggleDrawer}
                                        onClickPrincipalItem={toggleDrawer(false, PageLocation.INFLUENCER_HOME)} />
                                    <Divider />
                                </>
                            )}
                            {authContext.login.user.profile?.functionalities.findIndex(f =>
                                f.description == 'Acesso Submissão Influenciadores' ||
                                f.description == 'Acesso Submissão Campanhas' ||
                                f.description == 'Acesso Submissão Empresas'
                            ) >= 0 && (
                                    <>
                                        <MenuItemComponent
                                            key="influencer-menu"
                                            principalItemTitle="Solicitar Análise"
                                            toggleDrawer={toggleDrawer}
                                            isOpen={menuItemOpen === MenuItems.INFLUENCER_SUBMIT}
                                            openPrincipalItem={() => handleClickHeaderMenu(MenuItems.INFLUENCER_SUBMIT)}
                                            children={[
                                                {
                                                    title: 'Influenciadores',
                                                    pageLocation: PageLocation.INFLUENCER_SINGLE_PROFILE_SUBMIT,
                                                    show: authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Submissão Influenciadores') >= 0
                                                },
                                                {
                                                    title: 'Empresas, eventos e patrocínios',
                                                    pageLocation: PageLocation.INFLUENCER_SINGLE_COMPANY_SUBMIT,
                                                    show: authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Submissão Empresas') >= 0
                                                },
                                                {
                                                    title: 'Campanhas e projetos',
                                                    pageLocation: PageLocation.INFLUENCER_SINGLE_CAMPAIGN_SUBMIT,
                                                    show: authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Submissão Campanhas') >= 0
                                                },
                                            ]} />
                                        <Divider />
                                    </>
                                )}

                            {authContext.login.user.profile?.functionalities.findIndex(f =>
                                f.description == 'Acesso Classificação Influenciadores' ||
                                f.description == 'Acesso Classificação Campanhas' ||
                                f.description == 'Acesso Classificação Empresas'
                            ) >= 0 && (
                                    <>
                                        <MenuItemComponent
                                            key="influencer-menu"
                                            principalItemTitle="Classificação"
                                            toggleDrawer={toggleDrawer}
                                            isOpen={menuItemOpen === MenuItems.INFLUENCER_ClASSIFICATION}
                                            openPrincipalItem={() => handleClickHeaderMenu(MenuItems.INFLUENCER_ClASSIFICATION)}
                                            children={[
                                                {
                                                    title: 'Influenciadores',
                                                    pageLocation: PageLocation.INFLUENCER_PROFILE_CLASSIFICATION,
                                                    show: authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Classificação Influenciadores') >= 0
                                                },
                                                {
                                                    title: 'Empresas, eventos e patrocínios',
                                                    pageLocation: PageLocation.INFLUENCER_COMPANY_LIST,
                                                    show: authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Classificação Empresas') >= 0
                                                },
                                                {
                                                    title: 'Campanhas e projetos',
                                                    pageLocation: PageLocation.INFLUENCER_CAMPAIGN_LIST,
                                                    show: authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Classificação Campanhas') >= 0
                                                },
                                            ]} />
                                        <Divider />
                                    </>
                                )}
                            {authContext.login.user.profile?.functionalities.findIndex(f =>
                                f.description == 'Acesso Consulta Influenciadores' ||
                                f.description == 'Acesso Consulta Campanhas' ||
                                f.description == 'Acesso Consulta Empresas'
                            ) >= 0 && (
                                    <>
                                        <MenuItemComponent
                                            key="influencer-menu"
                                            principalItemTitle="Consulta"
                                            toggleDrawer={toggleDrawer}
                                            isOpen={menuItemOpen === MenuItems.INFLUENCER_CONSULT}
                                            openPrincipalItem={() => handleClickHeaderMenu(MenuItems.INFLUENCER_CONSULT)}
                                            children={[
                                                {
                                                    title: 'Influenciadores',
                                                    pageLocation: PageLocation.INFLUENCER_PROFILE_CONSULT,
                                                    show: authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Consulta Influenciadores') >= 0
                                                },
                                                {
                                                    title: 'Empresas, eventos e patrocínios',
                                                    pageLocation: PageLocation.INFLUENCER_COMPANY_CONSULT,
                                                    show: authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Consulta Empresas') >= 0
                                                },
                                                {
                                                    title: 'Campanhas e projetos',
                                                    pageLocation: PageLocation.INFLUENCER_CAMPAIGN_CONSULT,
                                                    show: authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Consulta Campanhas') >= 0
                                                },
                                            ]} />
                                        <Divider />
                                    </>
                                )}
                            {authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Inicial Influencers') >= 0 && (
                                <>
                                    <MenuItemComponent
                                        key="Faq-menu"
                                        principalItemTitle="FAQ"
                                        toggleDrawer={toggleDrawer}
                                        onClickPrincipalItem={toggleDrawer(false, PageLocation.FAQ)} />
                                    <Divider />
                                </>
                            )}
                            {authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso ao Dash Influencers ICE') >= 0 && (
                                <>
                                    <MenuItemComponent
                                        key="dashboard-menu"
                                        principalItemTitle="Dashboard"
                                        toggleDrawer={toggleDrawer}
                                        onClickPrincipalItem={toggleDrawer(false, PageLocation.DASHBOARD_INFLUENCER_BOTICARIO)} />
                                    <Divider />
                                </>
                            )}
                            {clientListEnable.length > 1 && (
                                <>
                                    {authContext.login.user.profile?.functionalities && (
                                        <>
                                            {authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Inicial Influencers') >= 0 && (
                                                <>
                                                    <MenuItemComponent
                                                        key="dashboard-menu"
                                                        principalItemTitle="Seleção de Cliente"
                                                        toggleDrawer={toggleDrawer}
                                                        onClickPrincipalItem={toggleDrawer(false, PageLocation.INFLUENCER_CLIENT_SELECT)} />
                                                    <Divider />
                                                </>
                                            )}
                                        </>
                                    )}
                                </>
                            )}

                        </>
                    )}
                </>
            )
                : (
                    <>
                        {clientListEnable.length > 1 && (
                            <>
                                {authContext.login.user.profile?.functionalities && (
                                    <>
                                        {authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Inicial Influencers') >= 0 && (
                                            <>
                                                <MenuItemComponent
                                                    key="dashboard-menu"
                                                    principalItemTitle="Seleção de Cliente"
                                                    toggleDrawer={toggleDrawer}
                                                    onClickPrincipalItem={toggleDrawer(false, PageLocation.INFLUENCER_CLIENT_SELECT)} />
                                                <Divider />
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </>

                )}
        </>
    );
}